module.exports = __webpack_public_path__ + "img/1_035.ba444e9d.jpg";